module.exports = __webpack_public_path__ + "img/AerWorx_logo16_reverse.ebcb0795.png";